// extracted by mini-css-extract-plugin
export default {"Wrapper":"SliderField_Wrapper__i6FY1","SliderField":"SliderField_SliderField__G5hZr","Label":"SliderField_Label__WyXox","DarkLabel":"SliderField_DarkLabel__XmJd5"};